import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { type CompareCalculator } from './Calculator';
import ComparisonCalculator from './ComparisonCalculator';
import { GridBox } from './ui';

type ComparisonContainerProps = {
    calculators: CompareCalculator[];
    setCalculators: (calculators: CompareCalculator[]) => void;
};

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ComparisonContainer = ({ calculators, setCalculators }: ComparisonContainerProps) => {
    const remove = useCallback(
        id => {
            setCalculators(calculators.filter(calculator => calculator.id !== id));
        },
        [calculators, setCalculators]
    );

    const comparisonCalculators = useMemo(
        () =>
            calculators.map(calculator => (
                <ComparisonCalculator
                    key={calculator.id}
                    dataSource={calculator.dataSource}
                    id={calculator.id}
                    remove={remove}
                />
            )),
        [calculators, remove]
    );

    return (
        <Container>
            <GridBox size={calculators.length}>{comparisonCalculators}</GridBox>
        </Container>
    );
};

export default ComparisonContainer;
